import { IconKid16, IconHospital16, IconMetroMsk16, IconStore16, IconSchool16 } from '@cian/ui-kit';
import * as React from 'react';

import { EType } from '../types/map';

export const INFRASTRUCTURE_MAP_ICON_MAP = new Map<string, React.FunctionComponent>([
  [EType.Clinic, IconHospital16],
  [EType.Grocery, IconStore16],
  [EType.Metro, IconMetroMsk16],
  [EType.Nursery, IconKid16],
  [EType.School, IconSchool16],
]);
